module.exports = __webpack_public_path__ + "static/media/visa.fb33b556.png";